import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../../actions/types";
import { CoreService } from "../../services";
import 'date-fns';
import * as yup from 'yup';
import { UserManagerService, PrivilegeManagerService, BiUserTransportService } from "../../services";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ConfirmDialog, WarnDialog } from "../../components/shared";
import SuccessDialog from '../../components/shared/SuccessDialog';
import {
    Avatar, Button, Backdrop, Box, TextField, Card, Checkbox,
    CircularProgress, Container, Divider, InputAdornment, IconButton, FormControl, FormLabel, Radio, RadioGroup,
    FormControlLabel, Grid, InputLabel, Tab, Tabs, Tooltip, Typography
} from '@material-ui/core';
import { Formik, Form, useFormik } from 'formik';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import allowAction from '../../helpers/allowAction';
import { AlertCircleOutline, CheckCircleOutline, EyeOutline, EyeOffOutline, Upload, ContentSave, Delete } from 'mdi-material-ui';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    formCard: {
        display: 'flex',
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: theme.palette.background.paper,
    },
    innerGrid: {

    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formFieldContainer: {
        display: 'flex',
        width: '46%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 8,
        marginTop: 8
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    textField: {
        width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    prefix: {
        width: 100,
        marginRight: 5
    },
    pictureButtonText: {
        color: theme.palette.type === 'light' ? theme.palette.text.secondary : theme.palette.background.paper,
        fontWeight: 'bold'
    },
    validationCondition: {
        textTransform: 'none',
    },
    alertIcon: {
        color: theme.palette.error.main
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    tabCard: {
        display: 'flex',
        marginTop: 6,
        marginBottom: 14,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary
    },
    saveButton: {
        marginRight: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    deleteButton: {
        marginLeft: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center',
        backgroundColor: theme.palette.error.main,
        color: 'white'
    },
    cancelButton: {
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}

            {...other}
        >
            {value === index && (
                <Container style={{ paddingRight: 0, paddingLeft: 0 }}>
                    <Box p={2}>
                        {children}
                    </Box>
                </Container>
            )}
        </div>
    );
}

const DisplayValidationTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        width: 'auto',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
    arrow: {
        color: 'lightgray',
        fontSize: 16,
    }
}))(Tooltip);

function nullToString(obj, isEditing) {
    for (var i in obj) {
        if (i === 'useDisable') {
            if (obj['useDisable'] === null) {
                obj['useDisable'] = 'F'
            }
        }
        else if (obj[i] === null) {
            obj[i] = ''
        }
    }
    return obj;
}

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

//#region Validation Schemas
const validationSchemaNotLdapCreating = yup.object({
    useId: yup.string().min(5, "Minimum 5 characters").required("Required"),
    useFirstName: yup.string().required("Required"),
    useLastName: yup.string().required("Required"),
    useEmail: yup.string().required("Required"),
    usePassword: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, "Upper and lowercase letters, at least one number").min(8, "Minimum 8 characters").required("Required"),
    reEnterPassword: yup.string().when('usePassword', (usePassword, field) =>
        usePassword ? field.required("You must re-enter the password").oneOf([yup.ref('usePassword')], "Passwords must match") : field
    ),
});
const validationSchemaLdapCreating = yup.object({
    useId: yup.string().min(5, "Minimum 5 characters").required("Required"),
    useFirstName: yup.string().required("Required"),
    useLastName: yup.string().required("Required"),
    useEmail: yup.string().required("Required"),
});
const validationSchemaNotLdapEditing = yup.object({
    useId: yup.string().min(5, "Minimum 5 characters").required("Required"),
    useFirstName: yup.string().required("Required"),
    useLastName: yup.string().required("Required"),
    useEmail: yup.string().required("Required"),
    usePassword: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, "Upper and lowercase letters, at least one number").min(8, "Minimum 8 characters"),
    reEnterPassword: yup.string().when('usePassword', (usePassword, field) =>
        usePassword ? field.required("You must re-enter the password").oneOf([yup.ref('usePassword')], "Passwords must match") : field
    ),
});
const validationSchemaLdapEditing = yup.object({
    useId: yup.string().min(5, "Minimum 5 characters").required("Required"),
    useEmail: yup.string().required("Required"),
    useFirstName: yup.string().required("Required"),
    useLastName: yup.string().required("Required"),
});

const getSchema = (isCreating, ldap) => {
    if (isCreating) {
        if (ldap === 'Yes') {
            return validationSchemaLdapCreating
        } else {
            return validationSchemaNotLdapCreating
        }
    } else {
        if (ldap === 'Yes') {
            return validationSchemaLdapEditing
        } else {
            return validationSchemaNotLdapEditing
        }
    }
}
//#endregion

export default function UserManagerCreate(props) {
    const dataPassedFromTable = useSelector((state) => state.userManager.formDataFromTableRow);
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);
    const isEditingUser = useSelector((state) => state.userManager.isEditingUser);
    const isCreatingUser = useSelector((state) => state.userManager.isCreatingUser);
    const positionOptions = useSelector((state) => state.dropdownMenuItems.position);
    const pageStore = useSelector((state) => state.privilegeManager.pages);
    const allUsers = useSelector((state) => state.userManager.allUsers);
   
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    const [tabValue, setTabValue] = useState(0);
    const [formData, setFormData] = useState(nullToString(dataPassedFromTable, isEditingUser))
    //Loading
    const [loadingTabData, setLoadingTabData] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    //FORM
    const [dataOperationTeam, setDataOperationTeam] = useState([]);
    const [dataRole, setDataRole] = useState([]);
    const [dataTransport, setDataTransport] = useState([]);
    const [dataTransportUpdate, setDataTransportUpdate] = useState([]);
    const [dataTransportSearch, setDataTransportSearch] = useState([]);
    const [searchTransport, setSearchTransport] = useState("");
    const [dataToUpdate, setDataToUpdate] = useState([]);
    const [dataRoleUpdate, setDataRoleUpdate] = useState([]);
    const [showPassword, setShowPassword] = useState(false)
    const [isLdap, setIsLdap] = useState(dataPassedFromTable.usePassword === '' && isEditingUser ? true : false);
    const [ldapRadio, setLdapRadio] = useState('');
    const [position, setPosition] = useState('');
    const [defaultPage, setDefaultPage] = useState('');
    const [rolesSelectedForPageOptions, setRolesSelectedForPageOptions] = useState([]);
    const [pagesByRole, setPagesByRole] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    //File
    const [selectedFile, setSelectedFile] = useState('');
    const hiddenFileInput = React.useRef(null);

    const formik = useFormik({
        initialValues: formData,
        validationSchema: getSchema(isCreatingUser, ldapRadio),
        validateOnChange: true,
        onSubmit: async (values) => {
            if (dataOperationTeam.findIndex(x => x.enable === 1) < 0) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Operation Team Required',
                    subTitle: <><Box component="div">Please select at least 1 Operation Team</Box></>,
                })
                return;
            } else if (dataRole.findIndex(x => x.enable === 1) < 0) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Role is Required',
                    subTitle: <><Box component="div">Please select at least 1 Role</Box></>,
                })
                return;
            } else if (!validateEmail(values.useEmail)) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Email is missing or invalid',
                    subTitle: <><Box component="div">Please provide a valid email address</Box></>,
                })
                return;
            } else if (isCreatingUser && allUsers.length > 0 && allUsers.findIndex(u => u.useId.toUpperCase() === values.useId.toUpperCase()) > -1) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Username must be unique',
                    subTitle: <><Box component="div">A user with username {values.useId} already exists</Box></>,
                })
                return;
            }

            else {
                try {
                    let addLdapFlag;
                    if (ldapRadio === 'No') {
                        addLdapFlag = { ...values, isLdap: false }
                    } else {
                        addLdapFlag = { ...values, isLdap: true }
                    }
                    await BiUserTransportService.saveUser(dataRoleUpdate, dataToUpdate, dataTransportUpdate, addLdapFlag)
                    history.push('/admin/user-manager/home')
                } catch (e) {
                    console.log(e.message)
                }
            }
        },
    });

    useEffect(() => {
        async function getPrivsByRole() {
            let allPrivs = [];
            for (let i = 0; i < rolesSelectedForPageOptions.length; i++) {
                let data = await PrivilegeManagerService.getPrivByRoleId({ rolId: rolesSelectedForPageOptions[i].roL_ID });
                allPrivs.push(data)
            }
            let pagesAllowed = allPrivs.flat().map(p => p.rolPriPrivileges.length > 1 && p.rolPriPrivileges[0] === "1" ? p.rolPriPageId : null).filter(z => z !== null)
            let filtered = pageStore.filter(x => pagesAllowed.includes(x.pagId) && x.pagId.length > 2 && x.pagId.length < 5)
            setPagesByRole(filtered);
        }
        if (pageStore.length > 0) {
               getPrivsByRole();
        } 
    }, [rolesSelectedForPageOptions])

    //if page reload, send user back to home
    if (!isEditingUser && !isCreatingUser) {
        history.push('/admin/user-manager/home')
    }

    const handleClickFileButton = (event) => {
        hiddenFileInput.current.click();
    }

    const handleChangeFile = async (event) => {
        let fileObject = event.target.files[0]
        let type = fileObject?.type;
        let okToSend;
        try {
            let b64 = await toBase64(event.target.files[0])
            switch (type) {

                case 'image/jpeg':
                    okToSend = b64.substring(23)
                    break;
                case 'image/png':
                    okToSend = b64.substring(22)
                    break;
                default:
                    okToSend = false;
            }
            if (okToSend) {
                setSelectedFile(fileObject);
                formik.setFieldValue('useProfile', okToSend)
            } else {
                setWarnDialog({
                    isOpen: true,
                    title: 'File type not supported',
                    subTitle: <><Box component="div">Please upload .jpeg or .png only</Box></>,
                })
                return;
            }
        } catch (e) {
            console.log(e)
        }
    };
    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['position']
        if (dropdownItemsStore) {
            for (var i = 0; i < dropdownToGet.length; i++) {
                if (dropdownItemsStore[dropdownToGet[i]].length !== 0) {
                    dropdownToGet = dropdownToGet.filter(function (item) {
                        return item !== dropdownToGet[i];
                    })
                }
            }
        }
        CoreService.dropdownItems(dropdownToGet).then(
            (response) => {
                if (response) {
                    const data = response.data;
                    dispatch({
                        type: SET_DROPDOWN_MENU_ITEMS_LIST,
                        payload: data,
                    });
                }
            });
    }, [dispatch]);

    useEffect(() => {
        if (dataPassedFromTable.usePassword === '' && isEditingUser) {
            setIsLdap(true)
            setLdapRadio('Yes')
        } else {
            setIsLdap(false)
            setLdapRadio('No')
            formik.setFieldValue('usePassword', '')
        }

    }, [dataPassedFromTable, isEditingUser])

    useEffect(() => {
        if (position.length === 0 && positionOptions.length > 0) {
            setPosition(positionOptions.filter(d => d.text === formData.usePosition))
            setIsLoading(false);
        }
    }, [positionOptions])

    useEffect(() => {
        if (formData.useDefaultPage) {
                setDefaultPage(pageStore.filter(d => d.pagUrl === formData.useDefaultPage))
        }
    }, [])

    useEffect(() => {
        async function getNewData() {
            let opTeamData = await UserManagerService.getOperationTeam(dataPassedFromTable.useId);
            setDataOperationTeam(opTeamData);

            let transportData = await BiUserTransportService.getUserTransportList(dataPassedFromTable.useId);
            setDataTransport([...transportData]);
            setDataTransportSearch([...transportData])

            let roleData = await UserManagerService.getRole(dataPassedFromTable.useId);
            setDataRole(roleData);
            setRolesSelectedForPageOptions(roleData.filter(d => d.enable === 1))
            setLoadingTabData(false);

        }
        getNewData()

    }, [dataPassedFromTable.useId]);

    useEffect(() => {
        const timeOutId = setTimeout((text) => {
            if (text.length === 0)
                setDataTransportSearch(dataTransport)
            else {
                text = text.toLowerCase();
                setDataTransportSearch(dataTransport.filter(v => v.name?.toLowerCase().match(text)))
            }
        }, 300, searchTransport);
        return () => clearTimeout(timeOutId);
    }, [searchTransport]);

    const handleAutocompleteChange = (target, fieldName) => {
        let text;
        let value;
        if (target === null) {
            text = '';
            value = '';
        } else {
            text = target.text
            value = target.value
        }

        if (fieldName === 'usePosition') {
            formik.setFieldValue(fieldName, text)
            formik.setFieldValue('usePositionId', value)
            setPosition([{ text: text, value: value }])
        }
        if (fieldName === 'useDefaultPage' && target) {
            formik.setFieldValue(fieldName, target.pagUrl)
            setDefaultPage([target])
        }
    };
    const handleTabChange = (e, newValue) => setTabValue(newValue);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleOpChange = (e) => {
        let ch;
        if (e.target.checked === true) {
            ch = '1'
        } else {
            ch = '0'
        }
        let found = dataToUpdate.find(t => t.OperationTeam === e.target.id)
        if (found) {
            let updatedObj = { 'UserId': formik.values.useId, 'OperationTeam': e.target.id, 'Enable': ch }
            let updatedArr = dataToUpdate.map(x => x.OperationTeam === e.target.id ? updatedObj : x)
            setDataToUpdate(updatedArr)
        } else {
            setDataToUpdate([...dataToUpdate, { 'UserId': formik.values.useId, 'OperationTeam': e.target.id, 'Enable': ch }]);
        }
        setDataOperationTeam(dataOperationTeam.map(x => x.teamid === e.target.id ? { ...x, enable: Number(ch) } : x))
    }

    const handleTransportChange = (e) => {
        let ch;
        if (e.target.checked === true) {
            ch = true
        } else {
            ch = false
        }
        let found = dataTransportUpdate.find(t => t.TransportId === e.target.id)
        if (found) {
            let updatedObj = { 'UserId': formik.values.useId, 'TransportId': e.target.id, 'Enable': ch }
            let updatedArr = dataTransportUpdate.map(x => x.TransportId === e.target.id ? updatedObj : x)
            setDataTransportUpdate(updatedArr)
        } else {
            setDataTransportUpdate([...dataTransportUpdate, { 'UserId': formik.values.useId, 'TransportId': e.target.id, 'Enable': ch }]);
        }
        setDataTransport(dataTransport.map(x => x.transportId === e.target.id ? { ...x, enable: ch } : x))
        setDataTransportSearch(dataTransportSearch.map(x => x.transportId === e.target.id ? { ...x, enable: ch } : x))
    }

    const handleTransportAllClick = (checked) => {
        var update = []
        var search = []
        var data = []
        var text = searchTransport?.toLowerCase();
        if (checked) {
            dataTransport.forEach(t => {
                if (t.enable !== true) {
                    update.push({ 'UserId': formik.values.useId, 'TransportId': t.transportId, 'Enable': checked });
                    data.push({ ...t, enable: checked });
                    if (t.name?.toLowerCase().match(text)) {
                        search.push({ ...t, enable: checked });
                    }
                } else {
                    data.push(t);
                    if (t.name?.toLowerCase().match(text)) {
                        search.push(t);
                    }
                }
            });
        } else {
            dataTransport.forEach(t => {
                if (t.enable === true) {
                    update.push({ 'UserId': formik.values.useId, 'TransportId': t.transportId, 'Enable': checked });
                    data.push({ ...t, enable: checked });
                    if (t.name?.toLowerCase().match(text)) {
                        search.push({ ...t, enable: checked });
                    }
                } else {
                    data.push(t);
                    if (t.name?.toLowerCase().match(text)) {
                        search.push(t);
                    }
                }
            });
        }
        setDataTransport(data)
        setDataTransportSearch(search)
        setDataTransportUpdate(update)
    }

    const handleRoleChange = (e) => {
        let ch;
        let chNum;
        if (e.target.checked === true) {
            ch = 'Y'
            chNum = 1
        } else {
            ch = 'N'
            chNum = 0
        }
        let found = dataRoleUpdate.find(t => t.UseRolRoleId === e.target.id)
        if (found) {
            let updatedObj = { 'UseRolUserId': formik.values.useId, 'UseRolRoleId': e.target.id, 'Check': ch }
            let updatedArr = dataRoleUpdate.map(x => x.UseRolRoleId === e.target.id ? updatedObj : x)
            setDataRoleUpdate(updatedArr)
        } else {
            setDataRoleUpdate([...dataRoleUpdate, { 'UseRolUserId': formik.values.useId, 'UseRolRoleId': e.target.id, 'Check': ch }]);
        }
        let updated = dataRole.map(x => x.roL_ID === e.target.id ? { ...x, enable: chNum } : x)
        setDataRole(updated)
        setRolesSelectedForPageOptions(updated.filter(d => d.enable === 1))
        
        if (formData.useDefaultPage) {
            let def = pageStore.filter(d => d.pagUrl === formData.useDefaultPage)
            setDefaultPage(def)
            formik.setFieldValue("useDefaultPage", formData.useDefaultPage)
        } else {
            setDefaultPage('')
            formik.setFieldValue("useDefaultPage", '')
        }
    }

    const handleDeleteUser = async () => {
        setConfirmDialog({
            isOpen: true,
            title: `Confirm`,
            subTitle: <><Box component="div">{`Are you sure you want to delete ${formData?.useId} from the system?`}</Box></>,
            onConfirm: async () => {
                try {
                    let response = await BiUserTransportService.deleteUser(formData?.useId)
                    if (response) {
                        history.push('/admin/user-manager/home')
                    }
                } catch (e) {
                    console.log(e.message)
                }
                setConfirmDialog({ ...confirmDialog, isOpen: false })
            }
        })
    }

    const handleChangeLdapRadio = (event) => {
        setLdapRadio(event.target.value)
    }

    //const handleUpdatePassword = async () => {
    //    if (!formik.errors.usePassword) {
    //        try {
    //            let res = await UserManagerService.updatePassword(formik.values)
    //            if (res) {
    //                setSuccessDialog({
    //                    isOpen: true,
    //                    title: 'Password Changed',
    //                    subTitle: <><Box component="div">The password has been changed successfully</Box></>,
    //                })
    //                formik.setFieldValue('usePassword', '')
    //                formik.setFieldValue('reEnterPassword', '')
    //            }
    //            console.log(res)
    //        } catch (e) {
    //            console.log(e)
    //        }
    //    }
    //}

    if (isLoading) {
        return (
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>)
    }
    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        {isCreatingUser ?
                            <> Create New User </>
                            :
                            <> Edit User </>
                        }
                    </h2>

                </div>

                <Grid container spacing={3}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10 }}>
                        {allowAction("50101", "edit") ?
                            <Button className={classes.saveButton} startIcon={<ContentSave />} onClick={formik.handleSubmit} size='small' variant='contained' color='primary'>
                                Save
                    </Button>
                            : null}
                        <Button className={classes.cancelButton} onClick={() => history.push('/admin/user-manager/home')} size='small' variant='contained' color='default'>
                            Cancel
                    </Button>

                        {isEditingUser && allowAction("50101", "delete") ?
                            <Button className={classes.deleteButton} startIcon={<Delete style={{ color: 'white' }} />} onClick={handleDeleteUser} size='small' variant='contained'>
                                Delete
                    </Button>
                            : ''}
                    </div>
                    <Card className={classes.formCard}>

                        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.innerGrid}>
                            <Formik>
                                <Form
                                    className={classes.form}
                                    onSubmit={formik.onSubmit}
                                >


                                    <div className={classes.formFieldContainer} style={{ width: '100%' }}>
                                        <InputLabel className={classes.inputLabel}>
                                            Username: <Typography component="span" color="error">*</Typography>
                                   </InputLabel>

                                        <TextField
                                            id="useId"
                                            name="useId"
                                            className={classes.textField}
                                            disabled={isEditingUser}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useId}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={Boolean(formik.errors.useId && formik.touched.useId)}
                                            helperText={formik.errors.useId === "Required" ? '' : formik.errors.useId}
                                        />

                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginLeft: 16, marginTop: 8 }}>
                                        <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                                            <FormLabel className={classes.inputLabel}>LDAP User: <Typography component="span" color="error">*</Typography></FormLabel>
                                            <RadioGroup aria-label="isLdap" name="isLdap" value={ldapRadio} onChange={handleChangeLdapRadio} style={{ display: 'flex', flexDirection: 'row', marginLeft: 10 }}>
                                                <FormControlLabel value="Yes" control={<Radio color='primary' />} label="Yes" />
                                                <FormControlLabel value="No" control={<Radio color='primary' />} label="No" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>

                                    {ldapRadio === 'No' ?
                                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                            <div className={classes.formFieldContainer}>
                                                <InputLabel className={classes.inputLabel}>
                                                    Password: <Typography component="span" color="error">*</Typography>
                                   </InputLabel>
                                               
                                                <TextField
                                                    id="usePassword"
                                                    name="usePassword"
                                                    className={classes.textField}
                                                    type={showPassword ? 'text' : 'password'}
                                                    variant='outlined'
                                                    placeholder={dataPassedFromTable && dataPassedFromTable.usePassword ? '\u2022'.repeat(8) : ''}
                                                    size="small"
                                                    value={formik.values.usePassword}
                                                    onBlur={formik.handleBlur}
                                                    InputProps={{
                                                        endAdornment:
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="show password"
                                                                    disabled={false}
                                                                    onClick={handleShowPassword}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? <EyeOutline /> : <EyeOffOutline />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                    }}
                                                    onChange={formik.handleChange}
                                                    error={Boolean(formik.errors.usePassword && formik.touched.usePassword)}
                                                    helperText={formik.errors.usePassword === 'Required' ? '' : formik.errors.usePassword}
                                                />

                                            </div>



                                            <div className={classes.formFieldContainer}>
                                                <InputLabel className={classes.inputLabel} style={{whiteSpace: 'nowrap'}}>
                                                    Re-enter Password:<Typography component="span" color="error">*</Typography>
                                   </InputLabel>
                                                
                                                <TextField
                                                    id="re-enter-password"
                                                    name="reEnterPassword"
                                                    className={classes.textField}
                                                    type={showPassword ? 'text' : 'password'}
                                                    style={{ marginLeft: 40 }}
                                                    placeholder={dataPassedFromTable && dataPassedFromTable.usePassword ? '\u2022'.repeat(8) : ''}
                                                    variant='outlined'
                                                    size="small"
                                                    value={formik.values.reEnterPassword}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={Boolean(formik.errors.reEnterPassword && formik.touched.reEnterPassword)}
                                                    helperText={formik.errors.reEnterPassword}
                                                />
                                            </div>
                                        </div>


                                        : <></>}

                                    <Divider orientation='horizontal' style={{ width: '97%', marginTop: 16, marginBottom: 16, marginLeft: 20, marginRight: 20 }} />

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            First Name: <Typography component="span" color="error">*</Typography>
                                   </InputLabel>
                                        <TextField
                                            id="usePrefix"
                                            name="usePrefix"
                                            className={classes.prefix}
                                            variant='outlined'
                                            size="small"
                                            label='Prefix-EN'
                                            value={formik.values.usePrefix}
                                            onChange={formik.handleChange} />
                                        <TextField
                                            id="useFirstName"
                                            name="useFirstName"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useFirstName}
                                            onChange={formik.handleChange}
                                            error={Boolean(formik.errors.useFirstName && formik.touched.useFirstName)}
                                        />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Last Name: <Typography component="span" color="error">*</Typography>
                                   </InputLabel>
                                        <TextField
                                            id="useLastName"
                                            name="useLastName"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useLastName}
                                            onChange={formik.handleChange}
                                            error={Boolean(formik.errors.useLastName && formik.touched.useLastName)}
                                        />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            First Name (TH):
                                   </InputLabel>
                                        <TextField
                                            id="usePrefixTh"
                                            name="usePrefixTh"
                                            className={classes.prefix}
                                            variant='outlined'
                                            size="small"
                                            label='Prefix-TH'
                                            value={formik.values.usePrefixTh}
                                            onChange={formik.handleChange} />
                                        <TextField
                                            id="useFirstNameTh"
                                            name="useFirstNameTh"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useFirstNameTh}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Last Name (TH):
                                   </InputLabel>
                                        <TextField
                                            id="useLastNameTh"
                                            name="useLastNameTh"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useLastNameTh}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <Divider orientation='horizontal' style={{ width: '97%', marginTop: 16, marginBottom: 16, marginLeft: 20, marginRight: 20 }} />

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Email: <Typography component="span" color="error">*</Typography>
                                   </InputLabel>
                                        <DisplayValidationTooltip
                                            title={<React.Fragment>
                                                {/*<Typography variant="subtitle2">Username must have:</Typography>*/}
                                                <Button
                                                    startIcon={
                                                        formik.values && formik.values?.useEmail && validateEmail(formik.values.useEmail)
                                                            ?
                                                            <CheckCircleOutline className={classes.checkIcon} />
                                                            :
                                                            <AlertCircleOutline className={classes.alertIcon} />
                                                    }
                                                    className={classes.validationCondition}>
                                                    <Typography variant="subtitle2">
                                                        Email is valid
                                            </Typography>
                                                </Button>

                                            </React.Fragment>}
                                            arrow
                                            placement="right"
                                        >
                                            <TextField
                                                id="useEmail"
                                                name="useEmail"
                                                className={classes.textField}
                                                variant='outlined'
                                                size="small"
                                                value={formik.values.useEmail}
                                                onChange={formik.handleChange}
                                                error={Boolean(formik.errors.useEmail && formik.touched.useEmail)}
                                            />
                                        </DisplayValidationTooltip>
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Mobile:
                                   </InputLabel>
                                        <TextField
                                            id="useMobilePhone"
                                            name="useMobilePhone"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.useMobilePhone}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Phone:
                                   </InputLabel>
                                        <TextField
                                            id="usePhone"
                                            name="usePhone"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.usePhone}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Position:
                                   </InputLabel>
                                        <Autocomplete
                                            id="usePosition"
                                            name="usePosition"
                                            closeIcon=""
                                            disabled={false}
                                            className={classes.textField}
                                            options={positionOptions}
                                            value={{ text: position[0]?.text, value: position[0]?.value }}
                                            getOptionLabel={(option) => option.text ? option.text : ''}
                                            getOptionSelected={(option, value) => option.value === value}
                                            renderOption={option => <>{option.text}</>}
                                            onChange={(event, newValue) => {
                                                handleAutocompleteChange(newValue, 'usePosition');
                                            }}
                                            renderInput={(params) => <TextField {...params}
                                                size="small"
                                                variant="outlined"
                                                style={{ width: 340 }}
                                                error={formik.touched.usePosition && formik.errors.usePosition ? Boolean(formik.errors.usePosition) : false}
                                                helperText={formik.touched.usePosition && formik.errors.usePosition ? formik.errors.usePosition : ""}
                                            />}
                                        />
                                    </div>
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Picture:
                                   </InputLabel>
                                        <Button
                                            onClick={handleClickFileButton}
                                            startIcon={<Upload />}
                                            variant='contained'
                                            className={classes.pictureButtonText}
                                            style={{ height: 36, width: 100, marginTop: 10, marginRight: 10 }}
                                        >
                                            Upload
                                        </Button>
                                        <input
                                            type='file'
                                            ref={hiddenFileInput}
                                            accept='image/jpeg, image/png'
                                            onChange={handleChangeFile}
                                            style={{ display: 'none' }}
                                        />
                                        {formik.values && formik.values.useProfile ?
                                            <Zoom openText="Zoom Image" zoomMargin={50} overlayBgColorStart={'rgba(255, 255, 255, 0)'} overlayBgColorEnd={'rgba(255, 255, 255, 0.65)'}>
                                                <div style={{ marginLeft: 4, marginTop: 4 }}>
                                                    <Avatar src={`data:image/jpeg;base64,${formik.values.useProfile}`} style={{ height: 44, width: 44 }} />
                                                </div>
                                            </Zoom>
                                            : null}

                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Default Page:
                                   </InputLabel>
                                        <Autocomplete
                                            key={defaultPage[0] + (Math.random() * 113).toString()}
                                            id="useDefaultPage"
                                            name="useDefaultPage"
                                            closeIcon=""
                                            disabled={false}
                                            noOptionsText='Please selected a Role first'
                                            className={classes.textField}
                                            options={pagesByRole.length > 0 ? pagesByRole : []}
                                            defaultValue={defaultPage[0] ? defaultPage[0] : ''} 
                                            getOptionLabel={(option) => option.pagName ? option.pagName : ''}
                                            getOptionSelected={(option, value) => option?.pagUrl === value?.pagUrl}
                                            renderOption={option => <>{option?.pagName}</>}
                                            onChange={(event, newValue) => {
                                                handleAutocompleteChange(newValue, 'useDefaultPage');
                                            }}
                                            renderInput={(params) => <TextField {...params}
                                                size="small"
                                                variant="outlined"
                                                style={{ width: 340 }}
                                                error={formik.touched.useDefaultPage && formik.errors.useDefaultPage ? Boolean(formik.errors.useDefaultPage) : false}
                                                helperText={formik.touched.useDefaultPage && formik.errors.useDefaultPage ? formik.errors.useDefaultPage : ""}
                                            />}
                                        />
                                    </div>

                                    {/*<div className={classes.formFieldContainer}>*/}
                                    {/*    <InputLabel className={classes.inputLabel}>*/}
                                    {/*        Company:*/}
                                    {/*   </InputLabel>*/}
                                    {/*    <TextField*/}
                                    {/*        id="company"*/}
                                    {/*        name="company"*/}
                                    {/*        className={classes.textField}*/}
                                    {/*        variant='outlined'*/}
                                    {/*        size="small"*/}
                                    {/*        value={formik.values.company}*/}
                                    {/*        onChange={formik.handleChange} />*/}
                                    {/*</div>*/}

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Enable:
                                   </InputLabel>
                                        <Checkbox
                                            name='useDisable'
                                            id='useDisable'
                                            checked={formik.values.useDisable === 'T' ? false : true}
                                            color='primary'
                                            onChange={() => {
                                                let val = formik.values.useDisable === 'F' ? 'T' : 'F'
                                                formik.setFieldValue('useDisable', val)
                                            }
                                            }
                                        />
                                    </div>
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Is Transporter:
                                        </InputLabel>
                                        <Checkbox
                                            name='isTransporter'
                                            id='isTransporter'
                                            checked={formik.values.isTransporter === 'T' ? true : false}
                                            color='primary'
                                            onChange={() => {
                                                let val = formik.values.isTransporter === 'T' ? 'F' : 'T'
                                                formik.setFieldValue('isTransporter', val)
                                            }
                                            }
                                        />
                                    </div>
                                    <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', paddingRight: 20}}>
                                        <Typography component="span" color="error">*Required</Typography>
                                    </div>
                                </Form>
                            </Formik>
                        </Grid>
                    </Card>
                    <Card className={classes.tabCard} style={{ width: '100%' }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} >
                            <Tabs value={tabValue} onChange={handleTabChange} indicatorColor='primary'>
                                <Tab label='Operation Team' style={{ fontSize: 14, textTransform: 'uppercase', fontWeight: 'bold' }} />
                                <Tab label='Role' style={{ fontSize: 14, textTransform: 'uppercase', fontWeight: 'bold' }} />
                                <Tab label='Transport' style={{ fontSize: 14, textTransform: 'uppercase', fontWeight: 'bold' }} />
                            </Tabs>
                            {!loadingTabData ?
                                <>
                                    <Grid container>
                                        <TabPanel value={tabValue} index={0} style={{ 'min-height': '200px', width: '100%' }}>
                                            {dataOperationTeam.map((dataO, i) => <FormControlLabel
                                                control={<Checkbox size='small' key={dataO.teamname} color='primary' defaultChecked={dataO.enable === 1} id={dataO.teamid} onChange={e => handleOpChange(e)} />}
                                                label={dataO.teamname}
                                                key={`${i}${dataO.teamname}`}
                                            />)}
                                        </TabPanel>
                                    </Grid>
                                    <Grid container>
                                        <TabPanel value={tabValue} index={1} style={{ 'min-height': '200px', width: '100%' }}>
                                            {dataRole.map((dataO, i) => <FormControlLabel
                                                control={<Checkbox size='small' color='primary' key={dataO.roL_ID} defaultChecked={dataO.enable === 1} id={dataO.roL_ID} onChange={e => handleRoleChange(e)} />}
                                                label={dataO.roL_DESCRIPTION}
                                                key={`${i}${dataO.roL_DESCRIPTION}`}
                                            />)}
                                        </TabPanel>
                                    </Grid>
                                    <Grid container>
                                        <TabPanel value={tabValue} index={2} style={{ 'min-height': '200px', width: '100%' }}>
                                            <div style={{ width: '100%' }}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: '100%' }}>
                                                    <Grid container spacing={1} style={{ width: '100%' }}>
                                                        <Grid item xs={1} sm={1} md={1} lg={1} className={classes.formFieldContainer}>
                                                            <InputLabel className={classes.inputLabel}>
                                                                Search:
                                                            </InputLabel>
                                                        </Grid>
                                                        <Grid item xs={3} sm={3} md={3} lg={3} >
                                                            <TextField
                                                                id="searchTransport"
                                                                name="searchTransport"
                                                                className={classes.textField}
                                                                variant='outlined'
                                                                size="small"
                                                                value={searchTransport}
                                                                onChange={(e) => setSearchTransport(e.target.value)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} lg={2} className={classes.formFieldContainer}>
                                                            <InputLabel className={classes.inputLabel} style={{ 'font-weight': 'unset' }}>
                                                                Found {dataTransportSearch.filter(d => d.enable === true).length}/{dataTransportSearch.length} of {dataTransport.filter(d => d.enable === true).length}/{dataTransport.length} record(s).
                                                            </InputLabel>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} lg={2} >
                                                            <Button onClick={() => handleTransportAllClick(true)} className={classes.saveButton} color='primary' style={{ width: '100%' }}>
                                                                Check all
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} lg={2} >
                                                            <Button onClick={() => handleTransportAllClick(false)} className={classes.saveButton} color='primary' style={{ width: '100%' }}>
                                                                Uncheck all
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={1} style={{ width: '100%' }}>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} >
                                                            {dataTransportSearch.map((dataO, i) => i >= 100 ? null : <FormControlLabel
                                                                control={<Checkbox size='small' color='primary' key={dataO.transportId} id={dataO.transportId} name="transporter" />}
                                                                label={dataO.name}
                                                                key={`${i}${dataO.name}`}
                                                                checked={dataO.enable === true}
                                                                onChange={e => handleTransportChange(e)}
                                                            />)}
                                                            <div style={{ color: 'red' }}>{dataTransportSearch.length > 100 ? `...(more ${(dataTransportSearch.length - 100)})...` : ''}</div>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </TabPanel>
                                    </Grid>
                                </>
                                :
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Box style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', height: 280, width: 'inherit', alignItems: 'center' }}>
                                            <CircularProgress />
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Card>

                </Grid>

            </Container >
            <SuccessDialog
                successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <Backdrop className={classes.backdrop} open={!formik.values}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};